import { useSetting } from "@/hooks/useStoreSettings";
import { useActiveAnnouncement } from "@/hooks/useMarketingBanners";
import { X } from "lucide-react";
import { useState } from "react";

const AnnouncementBar = () => {
  const [dismissed, setDismissed] = useState(false);
  const settingsAnnouncement = useSetting("announcement_bar", "");
  const campaignAnnouncement = useActiveAnnouncement();
  
  // Campaign notification takes priority, then settings announcement
  const text = campaignAnnouncement.data?.content?.headline || settingsAnnouncement;
  
  if (!text || dismissed) return null;

  return (
    <div className="relative bg-primary py-2 text-center text-xs font-medium text-primary-foreground sm:text-sm">
      <span>{text}</span>
      <button
        onClick={() => setDismissed(true)}
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1 hover:bg-primary-foreground/10"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
